import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { Field, Input } from '@hb/coffee';
import { checkTelPhone } from '@/shared/utils/validator';
import { SupplementInfoField } from '@/components/supplement-info-fields/types';
import { formatPhone344, emojFilter } from '../../utils';

@Component({ name: 'CompanyPhone' })
export default class CompanyPhone extends Vue implements SupplementInfoField {
  @Prop()
  private value!: string;

  /** 校验器  调用onValidator方法时会优先调用传入的校验器
   * (value, setErrorMsg) => boolean; value为当前输入框输入的值 setErrorMsg是一个设置校验错误信息的函数
  */
  @Prop()
  private validator: ((value: string, setErrorMsg: (msg: string) => void) => boolean) | undefined;

  private companyPhone = '';

  private errorMsg = '';

  private setErrorMsg(msg: string) {
    this.errorMsg = msg;
  }

  public onValidator(): boolean {
    const val = this.companyPhone;
    if (typeof this.validator === 'function') {
      return this.validator(val, this.setErrorMsg.bind(this));
    }

    if (!checkTelPhone(val)) {
      this.errorMsg = '请输入正确的公司电话';
      return false;
    }

    this.errorMsg = '';
    return true;
  }

  private created() {
    if (this.value) {
      this.companyPhone = this.value;
    }
  }

  @Watch('value')
  private onValueChange(val: string) {
    this.companyPhone = val;
  }

  private onChangeTelNumber(val: string) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private onBlur() {
    this.onValidator();
    this.$emit('blur');
  }

  private formatter(value: string) {
    return formatPhone344(emojFilter(value));
  }

  private render() {
    return (
      <Field
        label="公司电话"
        errorMessage={this.errorMsg}
      >
        <Input
          v-model={this.companyPhone}
          type="text"
          placeholder="请输入公司电话"
          formatter={this.formatter.bind(this)}
          on={{
            'update:modelValue': (val: string) => {
              this.onChangeTelNumber(val);
            },
          }}
          onBlur={this.onBlur.bind(this)}
        />
      </Field>
    );
  }
}
